var _rect, _rect2, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgQuestionMarkIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 15,
    height: 15,
    rx: 7.5,
    fill: "white"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 15,
    height: 15,
    rx: 7.5,
    stroke: "#9D9B9F"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.74992 9.94271V11.4688H7.20304V9.94271H8.74992ZM8.66659 9.30208H7.302C7.28117 8.19271 7.65617 7.73438 8.21867 7.32292C8.61971 7.02604 9.07284 6.76563 9.07284 6.23438C9.07284 5.77083 8.63534 5.43229 8.01554 5.43229C7.26554 5.43229 6.927 5.89063 6.90617 6.52083H5.33325C5.39575 5.02604 6.39054 4 8.02596 4C9.55721 4 10.6353 4.93229 10.6353 6.26042C10.6353 7.02083 10.2135 7.47396 9.69263 7.85417C9.09888 8.28125 8.677 8.49479 8.66659 9.30208Z",
    fill: "#9D9B9F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgQuestionMarkIcon);
export default __webpack_public_path__ + "static/media/question-mark-icon.02aa73fa48dc516c46733c7ca53f6de0.svg";
export { ForwardRef as ReactComponent };